module.exports = __webpack_public_path__ + "img/airtke_base.7db23b5a.png";